var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filters-component',{model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}}),_c('crud-component',{attrs:{"collection":"document","ui-schema":_vm.uiSchema,"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }